import { Component, OnInit, DoCheck, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { isUndefined, cloneDeep } from 'lodash';
import * as emailAddressHelper from 'email-addresses';
import * as validator from 'validator';

@Component({
  selector: 'app-email-outgoing-header',
  templateUrl: './email-outgoing-header.component.html',
  styleUrls: ['./email-outgoing-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BcEmailOutgoingHeaderComponent implements OnInit, DoCheck {
  public translateParams;
  public emailAddressType;
  public toFieldHasChanged;

  @Input()
  model;

  @Output()
  onSave: EventEmitter<object> = new EventEmitter();

  @Output()
  onCancel: EventEmitter<void> = new EventEmitter();

  @Output()
  onFromAddressChange: EventEmitter<object> = new EventEmitter();

  private _originalModel;
  private _previousToField;

  constructor() {
    this.translateParams = { invalidEmailList: '', invalidCcEmailList: '', invalidBccEmailList: '' };
    this.emailAddressType = { to: 'to', cc: 'cc', bcc: 'bcc' };
    this.toFieldHasChanged = false;
  }

  ngOnInit() {
    this._originalModel = cloneDeep(this.model);

    // Validate "to" field on start
    this.validateEmail(this.model.to, this.emailAddressType.to);
  }

  ngDoCheck() {
    // Watch changes on the "to" field to handle
    // - the state of the action buttons
    // - and the error message for the "to" field
    if (!this.toFieldHasChanged && this.model && this.model.to !== this._previousToField) {
      this.toFieldHasChanged = true;
      this._previousToField = this.model.to;
    }
  }

  validateEmail(emailBinding, validityBindingName) {
    const emailListParsed = emailBinding.split(';');
    const invalidEmails = [];
    let showInvalidMessage = false;

    emailListParsed.forEach((emailListItem) => {
      let curEmailIsInvalid = false;

      if (emailListItem.length !== 0) {
        const emailProcessed = emailAddressHelper.parseOneAddress(emailListItem) as emailAddressHelper.ParsedMailbox;
        if (isUndefined(emailProcessed) || emailProcessed === null) {
          curEmailIsInvalid = true;
        } else {
          curEmailIsInvalid = !validator.isEmail(emailProcessed.parts.address.tokens.trim(), { require_tld: true });
        }
      }

      if (curEmailIsInvalid) {
        invalidEmails.push(`'${emailListItem}'`);
      }
    });

    if (invalidEmails.length > 0 || this.isToFieldEmpty(emailBinding, validityBindingName)) {
      showInvalidMessage = true;
    }

    switch (validityBindingName) {
      case this.emailAddressType.to:
        this.model.to = emailBinding;
        this.model.emailToInvalid = showInvalidMessage;
        this.translateParams.invalidToEmailMessage = invalidEmails.length === 0 ? '' : (invalidEmails.length > 1 ? invalidEmails.join(', ') : invalidEmails[0]);
        break;
      case this.emailAddressType.cc:
        this.model.cc = emailBinding;
        this.model.emailCcInvalid = showInvalidMessage;
        this.translateParams.invalidCcEmailMessage = (invalidEmails.length > 1 ? invalidEmails.join(', ') : invalidEmails[0]);
        break;
      case this.emailAddressType.bcc:
        this.model.bcc = emailBinding;
        this.model.emailBccInvalid = showInvalidMessage;
        this.translateParams.invalidBccEmailMessage = (invalidEmails.length > 1 ? invalidEmails.join(', ') : invalidEmails[0]);
        break;
      default:
        throw new Error(`bc-email-outgoing-header - validateEmail - validityBindingName of ${validityBindingName} is not valid.`);
    }
  }

  isToFieldEmpty(fieldValue, fieldType) {
    return fieldValue === '' && fieldType === this.emailAddressType.to;
  }

  _save() {
    this.onSave.emit(this.model);
  }

  _cancel() {
    this.model = cloneDeep(this._originalModel);
    this.onCancel.emit(this.model);
  }

  _onFromAddressChange(selectedItem) {
    this.onFromAddressChange.emit(selectedItem);
  }
}
